import { lazy } from "react";
import { Route } from "react-router-dom";

const StaffLogin = lazy(() => import("./pages/StaffLogin.jsx"));
const StaffDashboard = lazy(() => import("./pages/StaffDashboard.jsx"));

export default function StaffRoutes() {
  return (
    <>
      <Route path="/staff" element={<StaffLogin />} />
      <Route path="/staff/dashboard" element={<StaffDashboard />} />
    </>
  );
}
